export default function HechoEnMexicoSection() {
  return (
    <section className="py-20 bg-[#fdf8f5] overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 md:px-8">

        {/* Header */}
        <div className="text-center mb-14">
          <span className="text-xs font-semibold text-[#d4607a] uppercase tracking-widest">
            Reconocimientos Oficiales
          </span>
          <h2
            className="text-3xl md:text-4xl font-bold text-[#2d1a0e] mt-2"
          >
            Certificados y Avalados
          </h2>
          <p className="text-[#6b5b6e] text-base mt-4 max-w-2xl mx-auto">
            Dos reconocimientos que respaldan nuestro compromiso con la producción nacional y el ecosistema de franquicias en México.
          </p>
        </div>

        {/* Two certifications side by side */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">

          {/* Card 1: Hecho en México */}
          <div className="rounded-3xl overflow-hidden flex flex-col">
            <div className="relative h-64">
              <img
                src="https://static.readdy.ai/image/707e9a4f9368999593f702b6caac5116/d28a6d3666fe494f79b4ab318c1f2bac.png"
                alt="Distintivo Hecho en México - San7o Pecado"
                className="absolute inset-0 w-full h-full object-cover object-center"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
              <div className="absolute bottom-5 left-6 flex items-center gap-3">
                <span className="text-3xl">🇲🇽</span>
                <div>
                  <p className="text-white font-bold text-base leading-tight">Hecho en México</p>
                  <p className="text-white/70 text-xs">Secretaría de Economía</p>
                </div>
              </div>
            </div>
            <div className="bg-white p-8 flex flex-col flex-1">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#006847]/10">
                  <i className="ri-award-line text-base text-[#006847]"></i>
                </div>
                <span className="text-[#006847] font-semibold text-xs uppercase tracking-wider">Sello Oficial SE</span>
              </div>
              <h3
                className="text-xl font-bold text-[#2d1a0e] mb-3 leading-tight"
              >
                Distintivo &quot;Hecho en México&quot;
              </h3>
              <p className="text-[#6b5b6e] text-sm leading-relaxed mb-6">
                Sello oficial otorgado por la <strong className="text-[#2d1a0e]">Secretaría de Economía</strong> a empresas que cumplen con estrictos requisitos de producción nacional. Avala que nuestros postres son elaborados con procesos, ingredientes y talento genuinamente mexicano.
              </p>
              <div className="flex flex-col gap-3 mt-auto">
                <div className="flex items-center gap-3">
                  <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#006847]/10 shrink-0">
                    <i className="ri-government-line text-xs text-[#006847]"></i>
                  </div>
                  <p className="text-[#6b5b6e] text-xs">Avalado por el gobierno federal mexicano</p>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#ce1126]/10 shrink-0">
                    <i className="ri-store-2-line text-xs text-[#ce1126]"></i>
                  </div>
                  <p className="text-[#6b5b6e] text-xs">Cumplimos requisitos de manufactura y producción local</p>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#006847]/10 shrink-0">
                    <i className="ri-heart-line text-xs text-[#006847]"></i>
                  </div>
                  <p className="text-[#6b5b6e] text-xs">Equipo, recetas y procesos 100% nacionales</p>
                </div>
              </div>
              <div className="flex rounded-full overflow-hidden h-1.5 w-32 mt-6">
                <div className="flex-1 h-full bg-[#006847]"></div>
                <div className="flex-1 h-full bg-gray-200"></div>
                <div className="flex-1 h-full bg-[#ce1126]"></div>
              </div>
            </div>
          </div>

          {/* Card 2: Asociación Mexicana de Franquicias */}
          <div className="rounded-3xl overflow-hidden flex flex-col">
            <div className="relative h-64">
              <img
                src="https://static.readdy.ai/image/707e9a4f9368999593f702b6caac5116/730d73fdf0ca40cfe995b911f87fbb59.png"
                alt="Reconocimiento XXVI Premio Nacional a la Franquicia - San7o Pecado"
                className="absolute inset-0 w-full h-full object-cover object-center"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
              <div className="absolute bottom-5 left-6 flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white/20">
                  <i className="ri-trophy-line text-xl text-white"></i>
                </div>
                <div>
                  <p className="text-white font-bold text-base leading-tight">XXVI Premio Nacional</p>
                  <p className="text-white/70 text-xs">Asociación Mexicana de Franquicias</p>
                </div>
              </div>
            </div>
            <div className="bg-white p-8 flex flex-col flex-1">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#00b4c8]/10">
                  <i className="ri-verified-badge-line text-base text-[#00b4c8]"></i>
                </div>
                <span className="text-[#00b4c8] font-semibold text-xs uppercase tracking-wider">Reconocimiento AMF · 2026</span>
              </div>
              <h3
                className="text-xl font-bold text-[#2d1a0e] mb-3 leading-tight"
              >
                XXVI Premio Nacional a la Franquicia — Promesa
              </h3>
              <p className="text-[#6b5b6e] text-sm leading-relaxed mb-6">
                La <strong className="text-[#2d1a0e]">Asociación Mexicana de Franquicias</strong> nos otorgó este reconocimiento como <strong className="text-[#2d1a0e]">Marca Finalista</strong> del XXVI Premio Nacional a la Franquicia en la categoría <strong className="text-[#2d1a0e]">Promesa</strong>, avalando nuestro liderazgo, calidad y compromiso. Expedido en Ciudad de México, 4 de marzo de 2026.
              </p>
              <div className="flex flex-col gap-3 mt-auto">
                <div className="flex items-center gap-3">
                  <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#00b4c8]/10 shrink-0">
                    <i className="ri-links-line text-xs text-[#00b4c8]"></i>
                  </div>
                  <p className="text-[#6b5b6e] text-xs">Integrados al ecosistema franquiciador mexicano</p>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#00b4c8]/10 shrink-0">
                    <i className="ri-shield-check-line text-xs text-[#00b4c8]"></i>
                  </div>
                  <p className="text-[#6b5b6e] text-xs">Modelo de franquicia transparente y profesional</p>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#00b4c8]/10 shrink-0">
                    <i className="ri-group-line text-xs text-[#00b4c8]"></i>
                  </div>
                  <p className="text-[#6b5b6e] text-xs">Red de 36 sucursales respaldada por la AMF</p>
                </div>
              </div>
              <div className="flex rounded-full overflow-hidden h-1.5 w-32 mt-6">
                <div className="flex-1 h-full bg-[#00b4c8]"></div>
                <div className="flex-1 h-full bg-[#c9b8f0]"></div>
                <div className="flex-1 h-full bg-[#d4607a]"></div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
